import SafeProvider from '@safe-global/safe-apps-react-sdk';
import { ConfigProvider, theme } from 'antd';
import { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAccount } from 'wagmi';
import LayoutDefault from './components/01.layout';
import { referralCodeIAO, removeAuthTokens } from './helpers/storage';
import { THEME_MODE } from './interfaces/theme';
import { RainbowProvider, useAuth } from './libs/rainbow';
import Routes from './routes/Routes';
import store, { useAppDispatch, useAppSelector } from './store';
import { clearUserInfo } from './store/actions/user';
import { IUserInfo } from './store/reducers/user';
import useVersionChecker from './useVersionCheck';
import { useConnectModal } from '@rainbow-me/rainbowkit';

const AppRoutes = () => {
  useVersionChecker();
  const userTheme = useAppSelector((state: any) => state.theme);
  const userInfo: IUserInfo = useAppSelector((state) => state.user);
  const [triggerOpenModal, setTriggerOpenModal] = useState(false);
  const { address: userAddress } = useAccount();
  const { openConnectModal } = useConnectModal();

  const { setAuthStatus } = useAuth();
  const dispatch = useAppDispatch();

  const darkMode = userTheme === THEME_MODE.DARK;
  localStorage.removeItem(referralCodeIAO);

  useEffect(() => {
    if (userInfo.walletAddress && userAddress && userInfo.walletAddress !== userAddress) {
      setAuthStatus('unauthenticated');
      removeAuthTokens();
      dispatch(clearUserInfo());
      setTriggerOpenModal(false);
      setTimeout(() => {
        setTriggerOpenModal(true);
      }, 1000);
    }
  }, [userAddress, userInfo.walletAddress, openConnectModal]);

  useEffect(() => {
    if (openConnectModal && triggerOpenModal) {
      openConnectModal();
      setTriggerOpenModal(false);
    }
  }, [openConnectModal, triggerOpenModal]);

  return (
    <ConfigProvider
      theme={{
        algorithm: darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: {
          fontFamily: 'Poppins',
        },
      }}
    >
      <LayoutDefault>
        <Routes />
      </LayoutDefault>
    </ConfigProvider>
  );
};

function App() {
  return (
    <SafeProvider>
      <Provider store={store}>
        <BrowserRouter>
          <RainbowProvider>
            <AppRoutes />
            <ToastContainer />
          </RainbowProvider>
        </BrowserRouter>
      </Provider>
    </SafeProvider>
  );
}

export default App;
